export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('.home-carousel-wrapper .carousel-slides').on('init', function() {
      $('.slide.slick-active').addClass('animdone');
    });

    $('.home-carousel-wrapper .carousel-slides').slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      appendDots: '.home-carousel-dots',
      speed: 1000,
      customPaging: function() {
        return '<button class="triangle-wrapper"><svg height="18" width="22" class="triangle"><polygon class="inner" points="9.3,2.3 16.3,13.5 2.4,13.5"/></svg></button>';
      },
    });

    $('.home-carousel-wrapper .carousel-slides').on('beforeChange', function(event, slick, currentSlide) {
      $('.slide[data-slick-index=' + currentSlide + ']').removeClass('animdone');
    });

    $('.home-carousel-wrapper .carousel-slides').on('afterChange', function() {
      $('.slide.slick-active').addClass('animdone');
    });

    var $homepagebanner = $('.page-banner-carousel');
    var firstslideremovable = true;

    $homepagebanner.on('afterChange', function(e, slick) {
      if(firstslideremovable) {
        $homepagebanner.slick('slickRemove', slick.currentSlide - 1);
        slick.currentSlide--;
        firstslideremovable = false;
      }

      if( slick.currentSlide == 0 ) {
        $homepagebanner.slick('setOption', 'autoplaySpeed', 5000);
      } else if( slick.currentSlide == 1 ) {
        $homepagebanner.slick('setOption', 'autoplaySpeed', 7000);
      }
    });

/*
    setTimeout(function() {
      $('.page-banner-title').animate({
        opacity: 1,
      }, 2000, function() {
        // Animation complete.
        setTimeout(function() {
          $('.page-banner-title').fadeOut( 'slow', function() {
            // Animation complete.
            $('.page-banner-text').fadeIn('slow');
          });
        }, 2000);
      });
    }, 500);*/
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js